// extracted by mini-css-extract-plugin
export default {"noBackground":"iha-z","qnaContainer":"jha-z","qna":"kha-z","question":"lha-z","modal":"mha-z"};